import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { Button, Modal } from '../../../components';
import { Divider } from 'antd';
import { toast } from 'react-toastify';
import { answerTicket } from '../../ticket.service';
import { TextArea } from '../../../components/textArea/textArea.index';
import { BsImage } from 'react-icons/bs';
import { useParams } from 'react-router-dom';

interface Props {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    onComplete: () => void;
}

export const AnswerTicketModal: FC<Props> = (props) => {
    const [messageText, setMessageText] = useState<string>('')
    const [selectedImage, setSelectedImage] = useState<File>();
    const [loading, setLoading] = useState<boolean>(false)
    const { ticketId } = useParams<{ ticketId: string }>();

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setSelectedImage(file);
        }
    };

    const handleSubmit = () => {
        const formData: FormData = new FormData()
        ticketId && formData.append("TicketId", ticketId)
        formData.append("MessageText", messageText)
        selectedImage && formData.append("AttachedMessage", selectedImage)

        const onComplete = () => {
            toast.success('تیکت شما با موفقیت ارسال شد.')
            props.onComplete()
            props.setOpen(false)
        }

        answerTicket(setLoading, formData, onComplete)
    }

    useEffect(() => {
        if (!props.open) {
            setMessageText('');
            setSelectedImage(undefined)
        }
    }, [props.open]);

    return (
        <Modal open={props.open} setOpen={props.setOpen} title={"ارسال پیام جدید"}>
            <Divider />
            <TextArea label={"پاسخ:"} value={messageText} onChange={(e) => setMessageText(e.target.value)} />
            <div
                className={`flex-1 mt-6 h-full w-full bg-background border border-primary-20 rounded-lg flex flex-col gap-3 items-center justify-center py-4 text-primary-100 clickable`}
                onClick={() => document.getElementById('file-input')?.click()}
            >
                {selectedImage ? (
                    <div className="rounded-lg overflow-hidden m-auto w-fit h-[80%]">
                        <img
                            src={URL.createObjectURL(selectedImage)}
                            alt="Selected"
                            className="h-full w-full object-contain"
                        />
                    </div>
                ) : (
                    <>
                        <BsImage size={24} />
                        <p className="text-sm font-medium">انتخاب فایل</p>
                    </>
                )}
                <input
                    id="file-input"
                    type="file"
                    accept=".jpg,.jpeg,.png,.heic"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
            </div>
            {selectedImage &&
                <Button type={"text"} className={"mt-2 w-full text-negative-dark"} onClick={() => setSelectedImage(undefined)}>حذف تصویر</Button>
            }
            <Button type={"primary"} className={"w-full mt-6"} onClick={handleSubmit} loading={loading} disabled={loading || !messageText}>ارسال پیام</Button>
        </Modal>
    )
}